import { getServiceAgreements, easyPrePayButton, invoiceAmountDue } from '../features/helpers/accountHelper';
import { Keywords } from '../constants/appConstants';

//Getting data from local storage. If paymentflag is true service agreements filter as per arbalnce>0
export const getDataFromLocalStorage = (accountdetails, paymentflag) => {
  
    let serviceAgreements = [];
    if(accountdetails && accountdetails.SalesAgreements){
        serviceAgreements = getServiceAgreements(accountdetails.SalesAgreements, paymentflag);
    }
    const { prePaydiscAmt, manageEasyPay } = easyPrePayButton(serviceAgreements);
    if(serviceAgreements.length>0 && paymentflag){
        let speduPrePayAgts = serviceAgreements.filter(item => item.ServiceAgreementType !== Keywords.easyPay && item.autoChgAcctRef && item.inactiveStatus === 'ACT');
        let svcAgreements = serviceAgreements.filter(item => (item.ServiceAgreementType === Keywords.easyPay && item.arBalance === 0 && item.inactiveStatus === 'ACT') || item.arBalance > 0);
        let spslPaymentAgts = serviceAgreements.filter(item => item.arBalance === 0 && item.inactiveReason === 'SSP' && item.inactiveStatus === 'INA' && item.ServiceAgreementType === Keywords.easyPay);
        let badDebtAgts = serviceAgreements.filter(item => item.isBadSalesAgreement === 'Y' && invoiceAmountDue(item) > 0 && item.inactiveReason !== 'SSP' && item.inactiveReason !== 'NRN');
        speduPrePayAgts.push(...svcAgreements);
        speduPrePayAgts.push(...spslPaymentAgts);
        speduPrePayAgts.push(...badDebtAgts);
        serviceAgreements = speduPrePayAgts;
    }
    return {
        serviceAgreements,
        prePaydiscAmt,
        manageEasyPay
    };
};